export class CircularProgressIndicator extends HTMLElement {
    static htmlTag: 'circular-progress-indicator' = 'circular-progress-indicator';

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback(): void {
        const size = Number(this.getAttribute('size') || '48');
        const strokeWidth = Number(this.getAttribute('stroke-width') || '4');
        const color = this.getAttribute('color') || 'currentColor';
        const radius = (size - strokeWidth) / 2;
        const circumference = 2 * Math.PI * radius;

        this.shadowRoot!.innerHTML = `
            <style>
                .progress-spinner {
                    animation: spinner-rotate 1.4s linear infinite;
                    transform-origin: center;
                }

                .progress-spinner-circle {
                    fill: transparent;
                    stroke: ${color};
                    stroke-linecap: round;
                    animation: dash 1.4s ease-in-out infinite;
                    stroke-dasharray: ${circumference};
                    stroke-dashoffset: 0;
                }

                @keyframes spinner-rotate {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }

                @keyframes dash {
                    0% {
                        stroke-dasharray: 1, ${circumference};
                        stroke-dashoffset: 0;
                    }
                    50% {
                        stroke-dasharray: ${circumference / 4}, ${circumference};
                        stroke-dashoffset: -${circumference / 4};
                    }
                    100% {
                        stroke-dasharray: 1, ${circumference};
                        stroke-dashoffset: -${circumference};
                    }
                }
            </style>
            <svg class="progress-spinner"
                viewBox="0 0 ${size} ${size}"
                width="${size}"
                height="${size}">
                <circle
                    class="progress-spinner-circle"
                    cx="${size / 2}"
                    cy="${size / 2}"
                    r="${radius}"
                    stroke-width="${strokeWidth}">
                </circle>
            </svg>
        `;
    }
}
